import apolloClient from '../../apolloClient';
import deviceHistoryQueries from 'src/gql/queries/deviceHistory';

const getDeviceHistoryByWorkspaceAndWorkspaceToWorkspace = async (variables) =>
  apolloClient.query({
    query:
      deviceHistoryQueries.GET_DEVICE_HISTORY_BY_WORKSPACE_ID_AND_WORKSPACE_TO_WORKSPACE,
    fetchPolicy: 'no-cache',
    variables,
  });

const getDeviceHistoryByDeviceId = async (variables) =>
  apolloClient.query({
    query: deviceHistoryQueries.GET_DEVICE_HISTORY_BY_DEVICE_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const getDeviceHistoryById = async (variables) =>
  apolloClient.query({
    query: deviceHistoryQueries.GET_DEVICE_HISTORY_BY_ID,
    fetchPolicy: 'network-only',
    variables,
  });

export default {
  getDeviceHistoryByWorkspaceAndWorkspaceToWorkspace,
  getDeviceHistoryByDeviceId,
  getDeviceHistoryById,
};
